import React from "react";
import { FaRegEyeSlash } from "react-icons/fa";
import {
    useEventContextV2,
    usePermissionsContext,
    useWhiteLabel,
} from "~/app/providers";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "~/components/v4/shadcn/Tooltip";
import { cn } from "~/utils/fontsConfig";

export const EventHiddenDateTime = () => {
    const customization = useWhiteLabel()?.customization;
    const event = useEventContextV2();
    const permissions = usePermissionsContext();
    const isHostLike = permissions.isHost || permissions.isManager;

    if (!event) return null;

    return (
        <React.Fragment>
            <div
                className={cn(
                    "flex h-12 w-12 flex-col items-center justify-center rounded-lg bg-v3-N-500",
                    // customization?.infobox?.bg,
                )}
            >
                <span
                    className={cn(
                        "text-sm text-v3-N-300",
                        customization?.inputLabelClassName,
                    )}
                >
                    {event.startTime.toLocaleString("en-US", {
                        year: "numeric",
                        timeZone: "UTC",
                    })}
                </span>
            </div>
            <div className="flex flex-col overflow-hidden">
                <span
                    className={cn(
                        "truncate text-white",
                        customization?.inputLabelClassName,
                    )}
                >
                    TBD
                </span>
                <span
                    className={cn(
                        "cursor-pointer truncate text-v3-N-300",
                        customization?.descriptionClassName,
                    )}
                >
                    Date not announced yet
                </span>
            </div>

            {isHostLike && (
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger>
                            <div className="flex justify-end gap-2">
                                <div
                                    className={cn(
                                        "flex h-12 w-12 cursor-pointer items-center justify-center rounded-lg bg-v3-N-500",
                                        customization?.buttons?.secondary,
                                    )}
                                >
                                    <FaRegEyeSlash
                                        className={cn(
                                            "h-5 w-5 text-white",
                                            // customization?.infobox?.content,
                                        )}
                                    />
                                </div>
                            </div>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p
                                className={cn(
                                    "w-[200px] text-sm",
                                    customization?.descriptionClassName,
                                )}
                            >
                                The exact event date and time are hidden.
                            </p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            )}
        </React.Fragment>
    );
};
